export default __webpack_public_path__ + "static/media/play.d0010f93.svg";